// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-chip-group {
  display: flex;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  padding: 4px 0;
}
:where(.vuetify-styles) .v-chip-group .v-chip {
  margin: 4px 8px 4px 0;
}
@media (forced-colors: active) {
  :where(.vuetify-styles) .v-chip-group .v-chip {
    background-color: buttonface !important;
    color: buttontext !important;
  }
  :where(.vuetify-styles) .v-chip-group .v-chip:hover {
    color: highlight !important;
  }
}
:where(.vuetify-styles) .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled) .v-chip__overlay {
  opacity: var(--v-activated-opacity);
}
@media (forced-colors: active) {
  :where(.vuetify-styles) .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled) {
    color: highlight !important;
    forced-color-adjust: preserve-parent-color;
  }
  :where(.vuetify-styles) .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled):focus-visible {
    outline-offset: 2px;
  }
  :where(.vuetify-styles) .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled).v-chip--variant-elevated, :where(.vuetify-styles) .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled).v-chip--variant-flat {
    background-color: highlight !important;
    color: highlighttext !important;
  }
  :where(.vuetify-styles) .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled).v-chip--variant-outlined, :where(.vuetify-styles) .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled).v-chip--variant-tonal {
    border-width: medium;
  }
}

:where(.vuetify-styles) .v-chip-group--column .v-slide-group__content {
  white-space: normal;
  flex-wrap: wrap;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VChipGroup/VChipGroup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,uCAAuC;IACvC,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,mCAAmC;AACrC;AACA;EACE;IACE,2BAA2B;IAC3B,0CAA0C;EAC5C;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sCAAsC;IACtC,+BAA+B;EACjC;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".v-chip-group {\n  display: flex;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n  padding: 4px 0;\n}\n.v-chip-group .v-chip {\n  margin: 4px 8px 4px 0;\n}\n@media (forced-colors: active) {\n  .v-chip-group .v-chip {\n    background-color: buttonface !important;\n    color: buttontext !important;\n  }\n  .v-chip-group .v-chip:hover {\n    color: highlight !important;\n  }\n}\n.v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled) .v-chip__overlay {\n  opacity: var(--v-activated-opacity);\n}\n@media (forced-colors: active) {\n  .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled) {\n    color: highlight !important;\n    forced-color-adjust: preserve-parent-color;\n  }\n  .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled):focus-visible {\n    outline-offset: 2px;\n  }\n  .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled).v-chip--variant-elevated, .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled).v-chip--variant-flat {\n    background-color: highlight !important;\n    color: highlighttext !important;\n  }\n  .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled).v-chip--variant-outlined, .v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled).v-chip--variant-tonal {\n    border-width: medium;\n  }\n}\n\n.v-chip-group--column .v-slide-group__content {\n  white-space: normal;\n  flex-wrap: wrap;\n  max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
